export { SessionPromptMessage } from "modules/newsletters/components/SessionPromptMessage/SessionPromptMessage"
